export enum SplitPaymentStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELED = "CANCELED",
  OVERDUE = "OVERDUE",
}

export interface SplitPayment {
  id: string;
  therapistId: string;
  patientId: string;
  patientName: string;
  appointmentId?: string;
  appointmentDate: Date | null;
  chargeId: string;
  chargeValue: number;
  therapistCommission: number;
  commissionValue: number;
  status: SplitPaymentStatus;
  createdAt: Date | null;
}
